<template>
  <BModal
    :id="modal.id"
    hide-header-close
    hide-footer
    hide-header
    size="sm"
    :centered="true"
    @hidden="$emit('on-close')"
  >
    <div
      class="position-absolute"
      style="right: 15px; top: 15px;"
    >
      <feather-icon
        icon="XIcon"
        class="cursor-pointer w-[20px] h-[20px]"
        @click="$bvModal.hide(modal.id)"
      />
    </div>
    <div class="text-center my-1">
      <img
        :src="`https://storage.googleapis.com/komerce/assets/icons/${modal.status}.svg`"
        alt="Komerce"
        class="m-auto w-[100px]"
      >
      <div class="font-semibold text-2xl text-black my-2">
        {{ modal.title }}
      </div>
      <p class="text-[#626262] mb-2">
        {{ modal.description }}
      </p>
    </div>
  </BModal>
</template>

<script>
export default {
  props: {
    modal: {
      type: Object,
      default: () => ({
        id: 'modal-alert',
        title: 'Judul Modal',
        description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
        status: 'warning',
      }),
    },
  },
}
</script>
